import React, { useState } from "react";
import navbarstyle from "../../style/navbar.module.less";
import { Logo } from "../common/Logo";
import { ThemeToggle } from "../common/ThemeToggle";
import useDevice from "../../hooks/useDevice";
import { APP_ORIGIN } from "../../lib/appBase";
import { useNetwork } from "../../solstack/lib/network";
import { NETWORKS } from "../../context/AppStore";

const LINKS = [
  { href: "/tools", label: "Tools" },
  { href: "#how", label: "How it works" },
  { href: "#faq", label: "FAQ" },
  { href: "/academy", label: "Academy" },
  { href: "/docs/overview", label: "Docs" },
  { href: "/blog", label: "Blog" },
];

export const NavBar = () => {
  const { isMobile } = useDevice();
  const { network, setNetwork } = useNetwork();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className={navbarstyle.bar}>
      <div className={navbarstyle.inner}>
        <a href="/" className={navbarstyle.brand} aria-label="Solstack home">
          <Logo size={isMobile ? 28 : 34} showText={!isMobile} />
        </a>

        <nav className={navbarstyle.links}>
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={navbarstyle.link}
              {...(l.external
                ? { target: "_blank", rel: "noreferrer" }
                : {})}
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* Desktop only — mobile gets the same controls inside the dropdown
            instead, so the row next to the burger stays down to just the
            CTA. */}
        <div className={navbarstyle.actions}>
          <span className={navbarstyle.desktopOnly}>
            <ThemeToggle />
          </span>
          <a href={APP_ORIGIN} rel="nofollow" className={`primary-button ${navbarstyle.cta}`}>
            Enter Solstack
          </a>
          <button
            type="button"
            className={navbarstyle.burger}
            aria-label="Menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>

        {menuOpen && (
          <nav className={navbarstyle.mobileMenu}>
            <div className={navbarstyle.mobileControls}>
              <div className="hp-net">
                <button
                  className={network === NETWORKS.DEVNET ? "active" : ""}
                  onClick={() => setNetwork(NETWORKS.DEVNET)}
                >
                  Devnet
                </button>
                <button
                  className={network === NETWORKS.MAINNET ? "active" : ""}
                  onClick={() => setNetwork(NETWORKS.MAINNET)}
                >
                  Mainnet
                </button>
              </div>
              <ThemeToggle />
            </div>
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className={navbarstyle.mobileLink}
                onClick={() => setMenuOpen(false)}
              >
                {l.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </div>
  );
};
